export default __webpack_public_path__ + "static/media/leviathanscall.97492924.png";